import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import it from "./locales/it.json";
import is from "./locales/is.json";
import i18n from "i18next";
import { SIMULATE } from "utils/constants";

export const resources = {
  en: { translation: en },
  it: { translation: it },
  is: { translation: is },
} as const;

i18n.use(initReactI18next).init({
  debug: SIMULATE,
  lng: "en",
  fallbackLng: "en",
  resources,
});
